"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExcessFormula["default"];
  }
});
var _ExcessFormula = _interopRequireDefault(require("./ExcessFormula"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }